import React, {
  ReactNode,
} from 'react';
import Spinner from 'pages/Dashboard/components/Spinner';

type Props = {
  isLoading?: boolean;
  loadingText?: string;
  children?: ReactNode;
};

export default function EmptyState({
  isLoading = false,
  loadingText = 'Loading...',
  children,
}: Props) {
  return (
    <div className="w-full h-full flex flex-1 justify-center items-center">
      {isLoading ? (
        <>
          <Spinner className="!font-bold" size={30} />
          <span className="mx-2">{loadingText}</span>
        </>
      ) : children}
    </div>
  );
}
